export const uz = {
  // NAV START
  'Home': 'Bosh sahifa',
  'Service' : 'Xizmatlarimiz',
  'Contact' : 'Aloqa',

  'HeroTitle' : 'inSITE Marketing -',
  'HeroTitleSec' : 'ishonchli loyihangiz uchun hamkor',
  'HeroText' : 'Shaxsiy brendingizni biz bilan rivojlantiring. Biz sizning maqsadlaringiz haqida qayg’uramiz va sizga eng yaxhi sifatni ulashishga jamomiz bilan astoydil harakat qilamiz bizga bildirgan ishonchingiz uchun "inSITE Marketing" jamoasi o’z minatdorchiligini bildiradi.',
  'HeroBtn' : 'BATAFSIL',

  'indicatorTitle' : 'Muvaffaqiyatli ishlarimiz soni',
  'indicatorTitle2' : 'MAMNUN MIJOZLAR',
  'indicatorTitle3' : 'XIZMAT TURLARI',
  'indicatorTitle4' : 'ISH TAJRIBAMIZ',
  'indicatorYear' : 'yil',

  'serviceTitle' : 'Xizmatlarimiz',
  'serviceType' : 'Veb saytlar',
  'serviceText' : 'Veb-saytingizni biz bilan yarating. Biz turli xildagi saytlarni siz istaganingizdek qilib yaratib beramiz.',
  'serviceType2' : 'Google reklama (SEO)',
  'serviceText2' : 'Google va Yandex qidiruv tizimida saytingizni profisional reklama qilib beramiz',
  'serviceType3' : 'Telegram bot',
  'serviceText3' : 'Telegram botingizni biz bilan yarating. Biz turli xildagi botlarni siz istaganingizdek qilib yaratib beramiz.',
  'serviceType4' : 'Veb dizayn',
  'serviceText4' : 'Web Dizayn | Sayt Uchun Ijodiy va Betakror G’oyalar',

  'advantagesTitle' : 'Bizning afzaliklarimiz',
  'advantagesType' : 'Tajribali jamoa a’zolari',
  'advantagesText' : 'Biznimg jamoamiz azolari o’z ishlarining mutaxasislari bo’lib o’z sohalari bo’yicha 1,5 yildan ortiq tajribaga ega va ma’sulyatlidirlar',
  'advantagesType2' : 'Texnik qo’llab quvatlash',
  'advantagesText2' : 'Loyiha yakunlangandan so’ng 3 oy davomida hodimlarimiz tamonidin nazorat qilinib turiladi',
  'advantagesType3' : 'Qulay narx va sifat',
  'advantagesText3' : 'Mangosteen Group o’z mijozlariga qulay narxlar bilan birgalikda a’lo darajadagi sifatni ham ulashadi',
  'advantagesType4' : 'Kafolatlangan xizmat',
  'advantagesText4' : 'Biz xizmatimiz kelishilinganidek bo’lishiga 100% kafolat beramiz va belgilangan mudatda kelishilingan xolda topshiramiz',
  'advantagesType5' : 'Profisional dizayn',
  'advantagesText5' : 'Biz dizaynga prodisional tarzda yondashamiz dizayn yagona boladi xechqanday nusxa emas',
  'advantagesType6' : 'Creative g’oyalar',
  'advantagesText6' : 'Bizning jamoa hamkorlik jarayonida yangi g’oyalar va takliflar bilan bo’lishadi',
 
  'accordionTitle' : 'Tez-tez so’raladigan savollar',
  'accordionType' : 'Sayt yaratishda nimalar kerak bo’ladi ?',
  'accordionText1.1' : 'Ish boshlash uchun kerak bo’ladi:',
  'accordionText1.2' : '— Logotip (agar mavjud bo’lsa);',
  'accordionText1.3' : '— Konsepsiya (firma ranglari);',
  'accordionText1.4' : '— Sayt uchun kontent (rasmlar, matnlar, fotosuratlar, videolar va boshqalar);',
  'accordionText1.5' : '— Istaklaringiz va talablaringiz;',
  'accordionType2' : 'Sayt yaratishga qancha vaqt ketadi ?',
  'accordionText2' : 'To’liq tayyor holdagi veb-saytlarni yaratish muddati xar xil bo’lishi va loyiha turiga qarab farq qilishi mumkin. Eng oddiy saytni ishga tushirish uchun 7 ish kuni kerak bo’ladi',
  'accordionType3' : 'Saytni ma’lumotlarini o’zim o’zgartira olamanmi ?',
  'accordionText3' : 'Ha, albatta, sizga ko’rsatmalar va kontentni boshqarish tizimiga kirish imkoniyati taqdim etiladi, bu juda qulay interfeysga ega, u intuitiv darajada tushunarli va maxsus bilimlarni talab qilmaydi.',
  'accordionType4' : 'Texnik yordamga nimalar kiradi?',
  'accordionText2.1' : 'Kunlik rezerv nusxa olish;',
  'accordionText2.2' : 'Yangi versiyasini o’rnatish;',
  'accordionText2.3' : 'Viruslardan himoya qilish;',
  'accordionText2.4' : 'Monitoring;',
  'accordionText2.5' : 'Ma’lumot yangilash;',
  'accordionType5' : 'Sayt bitgach texnik yordam ko’rsatasizlarmi?',
  'accordionText5' : 'Saytingizni topshirgandan keyin 3 oy davomida BEPUL texnik yordam ko’rsatamiz',

  'contactToasterSend' : 'Habaringiz yuborildi, tez orada siz bilan bog’lamiz',
  'contactToasterUnSend' : 'Habar yuborilmadi! Qaytadan urinib ko’ring 😞',
  'contactTitle' : 'Biz bilan aloqa',
  'contactRequest' : 'Savolingiz bormi?',
  'contactRequestText' : 'U holda quyidagi bo`limlarni to`ldiring, va bizga yuboring. Sizga tez orada javob beramiz!',
  'contactBtn' : 'Yuborish',

  'footerServiceTitle' : 'Xizmatlar',
  'footerServiceLink' : 'Veb sayt yaratish',
  'footerServiceLink2' : 'Telegram bot',
  'footerServiceLink3' : 'Veb dizayn',
  'footerServiceLink4' : 'Google va yandexda reklama',
  'footerAdvantagesTitle' : 'Bizning afzaliklarimiz',
  'footerAdvantagesLink' : 'Tajribali jamoa a’zolari',
  'footerAdvantagesLink2' : 'Texnik qo’llab quvatlash',
  'footerAdvantagesLink3' : 'Qulay narx va sifat',
  'footerAdvantagesLink4' : 'Kafolatlangan xizmat',
  'footerAdvantagesLink5' : 'Profisional dizayn',
  'footerAdvantagesLink6' : 'Kreativ g’oyalar',
  'footerContactPhone' : 'Biz bilan aloqa',
  'footerLastText' : '© 2023 insitemarketing.uz Barcha huquqlar himoyalangan',

  'servicePriceTitle' : 'Narxlar',
  'servicePriceLanding' : 'Landing page',
  'servicePriceLandingBonus' : 'Bizdan sizga',
  'servicePriceLandingList1' : 'Domen',
  'servicePriceLandingList2' : 'Hosting',
  'servicePriceLandingList3' : 'SSL sertifikat',
  'servicePriceLandingTime1' : 'Muddati 3 kun',
  'servicePriceConsultation' : 'Bepul Konsultatsiya',
  
  'servicePriceCatalog' : 'Katalog sayt',
  'servicePriceCatalogTime2' : 'Muddati 10/20 kun',
  'servicePriceCatalogPanel' : 'Admin panel',

  'servicePriceMagasine' : 'Internet magazin',
  'servicePriceMagasineTime' : 'Muddati 20/30 kun',
  'servicePriceMagasineXimoya' : 'Sayt ximoyasi',

  'servicePriceReklamaGoogle' : 'Google',
  'servicePriceReklamaList1' : 'Raqobatchilaringizning tahlili',
  'servicePriceReklamaList2' : 'Sayt tahlili + tavsiyalar',
  'servicePriceReklamaList3' : 'Taklif va byudjetni optimallashtirish',
  'servicePriceReklamaList4' : 'Kalit so‘z tanlash',
  'servicePriceReklamaList5' : 'Taklif va byudjetni optimallashtirish',
  'servicePriceReklamaList6' : 'Metrik ulanish',
  'servicePriceReklamaList7' : 'Haftalik hisobot',
  'servicePriceReklamaList8' : 'Moslashtirish vaqti: 5-7 kun',
  'servicePriceReklamaGoogleYandex2' : 'Moslashtirish vaqti: 7-10 kun',
  'servicePriceReklamaMonth' : 'oyiga',

  'servicePriceReklamaYandex' : 'Yandex',
  'servicePriceReklamaGoogleYandex' : 'Google + Yandex',
}